import { Request } from "@/utils";
import config from "@/configs";
import axios from "axios";
import { pool_uuid } from "@/config.json";

//用户主页
export async function staWorkNumHDay(params) {
  return Request.get(config.staWorkNumHDay, { params });
}
export async function staWorkNumHour(params) {
  return Request.get(config.staWorkNumHour, { params });
}
export async function staCalculDay(params) {
  return Request.get(config.staCalculDay, { params });
}
export async function staCalculHour(params) {
  return Request.get(config.staCalculHour, { params });
}
export async function staWorkNum(params) {
  return Request.get(config.staWorkNum, { params });
}
export async function getProfitGraphic(params) {
  return Request.get(config.getProfitGraphic, { params });
}
export async function getHashGraphic(params) {
  return Request.get(config.getHashGraphic, { params });
}
//资金管理
export async function getTotalFunds() {
  return Request.get(config.getTotalFunds, {});
}
export async function getLast24HoursProfit() {
  return Request.get(config.getLast24HoursProfit, {});
}
export async function getTotalWithdrawableAmount() {
  return Request.get(config.getTotalWithdrawableAmount, {});
}
export async function getTotalProfit() {
  return Request.get(config.getTotalProfit, {});
}
export async function setAutoWithdrawAmount(data) {
  return Request.post(config.setAutoWithdrawAmount, data);
}
export async function setAutoMoneyExchange(data) {
  return Request.post(config.setAutoMoneyExchange, data);
}

export async function getFundSummary() {
  return Request.get(config.getFundSummary, {});
}

//账户设置
export async function setWithdrawAddrSms(data) {
  return Request.post(config.setWithdrawAddrSms, { ...data, pool_uuid });
}
export async function setWithdrawAddr(data) {
  return Request.post(config.setWithdrawAddr, data);
}

export async function login(data) {
  return axios.post(config.loginUrl, data);
}

// export async function resetPassword(data) {
//   return axios.post(config.resetPassword, data);
// }

export async function getVerifyCode(data) {
  return axios.post(config.getVerifyCode, data);
}

export async function resetConfirm(data) {
  return axios.post(config.resetConfirm, data);
}

export async function register(data) {
  return axios.post(config.register, data);
}

export async function logout() {
  return Request.get(config.userLogout);
}
//
export async function getArticleList(params) {
  return Request.get(config.article, { params });
}

export async function getLoginLog() {
  return Request.get(config.getLoginLog, {});
}

export async function findUser() {
  return Request.get(config.findUser, {});
}

export async function setTimeZone(params) {
  return Request.get(config.setTimeZone, { params });
}

export async function editUser(data) {
  return Request.post(config.editUser, data);
}

export async function getGoogleAuthQrcode(params) {
  return Request.get(config.getGoogleAuthQrcode, { params });
}
export async function turnOffGoogleAuth(data) {
  return Request.post(config.turnOffGoogleAuth, data);
}
export async function turnOnGoogleAuth(data) {
  return Request.post(config.turnOnGoogleAuth, data);
}

export async function poolAccountList(params) {
  return Request.get(config.poolAccountList, { params });
}

// 用户面板
export async function userAccountList(params) {
  return Request.get(config.userAccountList, { params });
}

export async function userNewAddress(params) {
  return Request.get(config.userNewAddress, { params });
}

export async function listWithdraw(params) {
  return Request.get(config.listWithdraw, { params });
}

export async function setUserAccountapply(data) {
  return Request.post(config.setUserAccountapply, data);
}

export async function getAllBalance(params) {
  return Request.get(config.getAllBalance, { params });
}

export async function getWithDrawBalance(params) {
  return Request.get(config.getWithDrawBalance, { params });
}
export async function getWithdrawBSVFee(params) {
  return Request.get(config.getWithdrawBSVFee, { params });
}
export async function getWithdrawBTCFee(params) {
  return Request.get(config.getWithdrawBTCFee, { params });
}
export async function summary(params) {
  return Request.get(config.summary, { params });
}

export async function subUserListIndex(params) {
  return Request.get(config.subUserListIndex, { params });
}

export async function listEarn(params) {
  return Request.get(config.listEarn, { params });
}

export async function listExchange(params) {
  return Request.get(config.listExchange, { params });
}

export async function addSubUser(data) {
  return Request.post(config.addSubUser, data);
}

export async function coinEarn() {
  return Request.get(config.coinEarn);
}

// export async function editSub(data) {
//   return Request.post(config.editSub, data);
// }

// export async function getDefaultSubAccount() {
//   return Request.get(config.getDefaultSubAccount);
// }

export async function getSubSummary(params) {
  return Request.get(config.getSubSummary, { params });
}

export async function getBalance(params) {
  return Request.get(config.getBalance, { params });
}

export async function subUserList(params) {
  return Request.get(config.subUserList, { params });
}

export async function workerList(params) {
  return Request.get(config.workerList, { params });
}

export async function workerGroup(params) {
  return Request.get(config.workerGroup, { params });
}

export async function addGroup(data) {
  return Request.post(config.addGroup, data);
}

export async function editGroup(data) {
  return Request.post(config.editGroup, data);
}

export async function delGroup(data) {
  return Request.post(config.delGroup, data);
}

export async function getObserverKey(params) {
  return Request.get(config.getObserverKey, { params });
}

export async function getOberverList(data) {
  return Request.post(config.getOberverList, data);
}

export async function setMining(data) {
  return Request.post(config.setMining, data);
}

export async function getRate() {
  return Request.get(config.getRate);
}

export async function saveExchange(data) {
  return Request.post(config.saveExchange, data);
}

export async function getWorkerBillList(data) {
  return Request.post(config.getWorkerBillList, data);
}

export async function getBillEmail(data) {
  return Request.post(config.getBillEmail, data);
}

export async function setBillMailAddr(data) {
  return Request.post(config.setBillMailAddr, data);
}

export async function switchList(params) {
  return Request.get(config.switchList, { params });
}

export async function autobtcList(params) {
  return Request.get(config.autobtcList, { params });
}

export async function listManualRec(params) {
  return Request.get(config.listManualRec, { params });
}

//共享费率
export async function changeRateMinute(params) {
  return Request.get(config.changeRateMinute, { params });
}
export async function changeRateHour(params) {
  return Request.get(config.changeRateHour, { params });
}
export async function changeRatetDay(params) {
  return Request.get(config.changeRatetDay, { params });
}

export async function setMonitor(data) {
  return Request.post(config.setMonitor, data);
}

export async function setObserver(data) {
  return Request.post(config.setObserver, data);
}

export async function delObserver(data) {
  return Request.post(config.delObserver, data);
}
export async function getBlock(params) {
  return Request.get(config.getBlock, { params });
}
export async function getPoolAmount(params) {
  return Request.get(config.getPoolAmount, { params });
}

//子账户设置
export async function setSubuserWithdrawAddr(data) {
  return Request.post(config.setSubuserWithdrawAddr, data);
}
export async function setWithdraw(data) {
  return Request.post(config.setWithdraw, data);
}
export async function setExchange(data) {
  return Request.post(config.setExchange, data);
}
// 提现
export async function withDrawApply(data) {
  return Request.post(config.withDrawApply, data);
}
export async function withDrawMainApply(data) {
  return Request.post(config.withDrawMainApply, data);
}
// export async function subWithDrawSingle(data) {
//   return Request.post(config.subWithDrawSingle, data);
// }
export async function subWithDraw(data) {
  return Request.post(config.subWithDraw, data);
}
export async function getAverageFee(data) {
  return Request.post(config.getAverageFee, data);
}

//获取apk
export async function getOneAppVersion() {
  return Request.get(config.getOneAppVersion, {});
}

export async function delOffline() {
  return Request.get(config.delOffline, {});
}

export async function moveMiner(data) {
  return Request.post(config.moveMiner, data);
}
// v3.5 借贷合约
export async function getLoanList(params) {
  return Request.get(config.getLoanList, { params });
}

// v3.7.7 子账户隐藏
export async function setHidden(data) {
  return Request.post(config.setHidden, data);
}

// v3.8.0
export async function walletAuth(data) {
  return Request.post(config.walletAuth, data);
}

// 获取验证码
// {
//   account: string;
//   mobile_prefix?: string;
//   code_type: "reset_password" | "signup" | "signin";
// }
export async function sendCode(data) {
  return Request.post(config.getcode, data);
}

export async function getSetting(params) {
  return Request.get(config.getSetting, { params });
}

export async function getSubUserInfo(params) {
  return Request.get(config.getSubUserInfo, { params });
}

export async function getFee(params) {
  return Request.get(config.getFee, { params });
}
